module.exports = __webpack_public_path__ + "img/battery-success.ab23cb4c.svg";